var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_936",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_936",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAEaElEQVR4nO2dz08cZRjHP+87S9TozWistnrowZ70YCV1u0CpJoQu1Gup0cSYcPBSlgYP1aOcLLtwMCYmJp7K2QCrVBRcFmxB/RPUij+aFi9qYyPsvB52D0SGAvu+y7PI8znOzH6fd+az8877zibvgqIoiqIoykHESDcgiZPZwU6D6wM6gCeAB+uMuoPhZxwljLtSnhydC9fKMDSVgEzvhSeJ7cdAZ4NKfGFT5vXSJ/mVBuXvmqYRkMlefM4QTzt4uMGlVo11XfMTo981uM6OaAoB6TMXn7ImXgYe2ZOChls2Mseb4U6w0g0AsDb+gL26+ACOR+M19/6e1bsH4ndAuvfC8za2SzLV7fHy1Mi3MrWrpCSLA0Sxfc0l77prHJciUuNzxfdu1pPd1jVwyLXYPpwbBu7fdICLXwUOtgAHJ5K2G8el+WKh4JM9Pz36G5DPZHMGuLypBibtkx+ChnRBG8bxbcAR6hjHp1zqUL3f/P/S1jVwyKXMr3V89A6wApQwbrwR84igd0C6e+ioidY/NM6d9s2qVNbEn09UvzjHgGM405/J5masjfpLE5d/CFUg2CioPTuYjuz6dePwvvgArsX2hcgBiFO8EijqpTiuLKV7Bl4IlBemC0p3Dx2N7Pr1wJOouxjztlmLx2t9+a6pdT3ngWHgvoBtW7U2ag1xJwQRkMnmZoAXQ2TtI2bLUwXvu927C2rvHjjNwbv4AJ2ZnoFTviHeD+HYmnNb7NrxOL72KuIa8Jhve3bIzdjZE4vFkRv3Omj7eQTnAK+Rkf9D2NCeuLk2jt/JUHKxOHIjtvFZA797t2d7Vp2jd7uLD9V5RHkynwfeST7CJJ77bvAX4Hg8aXNEanw3MYsTY8tx1PIMMOPdpi0wjqsuanl2oVj4ZlefW3dXtth12LtNvgGZbC7xTUJ5qlB3dltPrtU53qD6u8Bh4IE6o/4GVsDNxtZ9tDgxtlxvmxpxntAEryKSmJ8sLAFCL+j2lqZ4HX2QUQHCqABhVIAwKkAYFSCMChBGBQijAoRRAcKoAGFUgDAqQBgVIIwKEEYFCKMChFEBwqgAYVSAMCpAGBUgjAoQRgUIowKEUQHCqABhVIAwKkAYFSCMChBGBQijAoRRAcKoAGFUgDAqQBgVIIwKEEYFCKMChFEBwqgAYVSAMCpAGBUgjAoQRgUIowKEUQHCqABhVIAwIQT8mbTx1JmhvVqEteGcPPtW4tKcwB++2SEWbk1cl3/dVs57ZzcLlX+2OpdffKP9l610fAU8vXm7G870DOKz+rk0G1Zffzdpv6meuxfeC7fW/i3jS9+c/Yh1cUepOFbyyvBtxMJUfhbc5745+w8z7XvxIdAoKFWhH7gdIms/UF1k3L0ZIiuIgLnPRn+MjXsZWA2R1+TcjmPTU54qfB8iLNg8YHFy9Gtro9b/c3dkHFdTFde68Gn+WrDMUEEbaevNdbjY9dXW1z8CPNSIOnvAX8BPxlEyxOMh+nxFURRFURRFURRFOdj8C3k4PGXr3US8AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStewards);
export default __webpack_public_path__ + "static/media/stewards.3ee3d70cdafc0b3e50a717a637e32a38.svg";
export { ForwardRef as ReactComponent };